export default async function () {
  // Läuft nur im Browser
  if (import.meta.client) {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://documentcloud.adobe.com/view-sdk/main.js'
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
}
